const OrganizationCard = ({
  user,
  hasMore = false,
  photoPath = "",
  onClick = () => {},
  highlightedUserId = null,
}) => {
  return (
    <div
      className={`org-card ${hasMore ? "hasmore" : ""} ${
        highlightedUserId === user.userId ? "highlighted" : ""
      }`}
      onClick={onClick && (() => onClick(user.userId))}
      role={onClick ? "button" : "presentation"}
      tabIndex={0}
    >
      <div className="thumb">
        <img
          src={
            user.profilePhoto
              ? `${photoPath}/${user.profilePhoto}`
              : "/public/images/thumb-user.svg"
          }
          alt="Profile"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/public/images/thumb-user.svg";
          }}
        />
      </div>
      <div className="text">
        <h3>
          {user.userName} <span>#{user.userEmployeeId}</span>
        </h3>
        {user.designation && (
          <div className="designation">{user.designation}</div>
        )}
        {user.department && <div className="department">{user.department}</div>}
      </div>
      {highlightedUserId === user.userId && hasMore && (
        <div className="arrow">
          <span className="material-icons-outlined">keyboard_arrow_right</span>
        </div>
      )}
    </div>
  );
};

export default OrganizationCard;
